import { Fragment } from 'react';
import Link from './Link';
import { CONTENT_CLASSES } from '../constants/classNames';

/**
 * "Lab › Elements › Iron" trail at the top of content pages. The last item is the current page.
 */
export default function Breadcrumbs({ trail }) {
  return (
    <nav className={CONTENT_CLASSES.breadcrumbs} aria-label="Breadcrumb">
      {trail.map(({ label, path }, index) => (
        <Fragment key={label}>
          {index > 0 && <span aria-hidden="true"> › </span>}
          {index < trail.length - 1 ? (
            <Link to={path} className={CONTENT_CLASSES.breadcrumbLink}>
              {label}
            </Link>
          ) : (
            <span aria-current="page">{label}</span>
          )}
        </Fragment>
      ))}
    </nav>
  );
}
